import { useEffect, useState } from 'react';

import { Button, If, InfoPayment, Offerta } from '@ui';
import { checkFeeInfo, getAmountSStorage, numberFormat } from '@utils';
import { ITransactionType } from '@entities/checkout';
import { AmountButton } from '@entities/amount-button';
import { BASE_URL_LOGOS, TransactionGroupTypes } from '@constants';

import { IProcardpayProps } from './types';
import { usePayLinkProcardpayQuery } from './api';

export const ProcardpayForm = ({
  checkout,
  type,
  isTokenization = false,
  enterAmount,
}: IProcardpayProps) => {
  const [clientAmount, setClientAmount] = useState<string>('');
  const [isCalculated, setIsCalculated] = useState<boolean>(true);

  const showInfoPaymentInAmountButton = Boolean(
    enterAmount?.payload?.enterAmount
  );

  const checkIsCalculated = showInfoPaymentInAmountButton
    ? isCalculated
    : false;

  const { mutate, isPending } = usePayLinkProcardpayQuery(
    enterAmount?.payload?.sessionToken ?? ''
  );

  const infoPay: ITransactionType | undefined =
    checkout?.transactionTypes?.find(
      (transactionType) => transactionType.groupName === type
    );

  const max: string = checkFeeInfo('max', String(infoPay?.feeInfo.max));
  const min: string = checkFeeInfo(
    'min',
    String(infoPay?.feeInfo.min),
    `${max ? ',' : ''}`
  );
  const infoStatic: string = checkFeeInfo(
    ' +',
    String(infoPay?.feeInfo.static),
    ','
  );

  const logos: ITransactionType[] | undefined =
    checkout?.transactionTypes?.filter(
      (checkout) => checkout.groupName === TransactionGroupTypes.Procardpay
    );

  useEffect(() => {
    const amount = getAmountSStorage();
    if (amount !== null) {
      setClientAmount(amount);
    } else {
      setClientAmount('');
    }
  }, []);
  return (
    <div className="-ml-[150px] -mr-[150px] mt-5 rounded-xl bg-white p-[96px] sm:m-auto sm:rounded-none sm:p-7">
      <AmountButton
        value={clientAmount}
        onClientAmount={(e) => setClientAmount(e.target.value)}
        type={type}
        showInfoPayment={showInfoPaymentInAmountButton}
        enterAmountData={enterAmount}
        disabled={getAmountSStorage() !== null}
      />

      <If
        condition={Boolean(
          checkout && !isTokenization && !showInfoPaymentInAmountButton
        )}
      >
        <InfoPayment
          className="my-4"
          info={[
            {
              label: 'Комиссия',
              value: `${numberFormat(Number(infoPay?.totalFee ?? 0))} c. ( ${infoPay?.feeInfo?.percent ?? 0}%${infoStatic}${max || min ? ',' : ''}
                    ${min} ${max})`,
            },
            {
              label: 'Сумма к зачислению',
              value: `${numberFormat(Number(checkout?.amount))} с.`,
            },
            {
              label: 'К оплате',
              value: `${numberFormat(Number(infoPay?.totalAmount))} с.`,
            },
          ]}
        />
      </If>
      <Button
        type="submit"
        className="mb-4 mt-5 w-full justify-center"
        isLoading={isPending}
        disabled={checkIsCalculated && getAmountSStorage() === null}
        onClick={() =>
          mutate(undefined, {
            onSuccess() {
              setClientAmount('');
            },
          })
        }
      >
        Оплатить
      </Button>

      <Offerta isTokenization={isTokenization} />
      <div className="mt-14 flex items-center justify-center gap-3 gap-x-6 sm:mt-7 sm:overflow-x-scroll">
        {logos?.map((logo: ITransactionType) => (
          <img
            alt="Logo"
            key={logo.logoInfo}
            className="h-[40px] w-[60px] object-contain transition-transform hover:scale-[1.1]"
            src={`${BASE_URL_LOGOS}/logos/${logo.logoInfo}`}
          />
        ))}
      </div>
    </div>
  );
};
